import { Button, Card, Radio, Select, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import BackButtonIcon from "../../../assets/icons/BackButtonIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import UserIcon from "../../../assets/icons/UserIcon";
import TopCard from "../../../components/common/TopCard";
import CustomTable from "../../../components/ui/CustomTable";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { addKeyInArray } from "../../../utils/utils";

interface LogItem {
  time: string;
  date: string;
  message: string;
  user: string;
  role: string;
  status: "success" | "warning" | "error";
}

const logs: LogItem[] = [
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "This Business Activated Successfully!",
    user: "Md Abdul Hamid",
    role: "System Admin",
    status: "success",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "Request to Active This Business",
    user: "Md Abdul Hamid",
    role: "Finance Admin",
    status: "warning",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "This Business Inactivated Successfully!",
    user: "Md Abdul Hamid",
    role: "System Admin",
    status: "error",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "Request to Inactive This Business",
    user: "Md Abdul Hamid",
    role: "Business Team",
    status: "warning",
  },
];

const statusColors = {
  success: "bg-green-500",
  warning: "bg-yellow-400",
  error: "bg-red-500",
};

export default function BusinessPackageDetails() {
  const navigate = useNavigate();
  const { page, limit, handlePagination, handleLimit } = useTable();

  const columns: ColumnsType<LeaveDataType> = [
    {
      title: "transactions ID",
      dataIndex: "transactionsID",
    },
    {
      title: "Account No.",
      dataIndex: "accountNo",
    },
    {
      title: <div className="w-[90px]">Date</div>,
      dataIndex: "date",
    },

    {
      title: <div className="w-[90px]">Status</div>,
      dataIndex: "status",
      align: "center",
      render: (value: string) => {
        const isTrial = value.includes("Trial");
        const isTrialExpired = value === "Trial Expired";
        const displayValue = isTrialExpired ? "Inactive" : value;

        return (
          <span
            className={`px-2 py-1 rounded text-xs font-medium ${
              displayValue === "Active"
                ? "bg-green-100 text-green-600"
                : displayValue === "Inactive"
                ? "bg-red-100 text-red-600"
                : isTrial
                ? "bg-[#F0F3F9] text-[#5E718D]"
                : "bg-yellow-100 text-yellow-600"
            }`}
          >
            {displayValue}
          </span>
        );
      },
    },
    {
      title: <div className="w-[90px]">Amount (tk)</div>,
      dataIndex: "amount",
      align: "right",
    },
  ];

  return (
    <SidebarLayout title="Business Details ">
      <TopCard
        leftChildren={
          <Button
            className="normal-dark-button"
            icon={<BackButtonIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        }
      >
        <div className="flex gap-2 items-center">
          <span>Business Status</span>
          <Switch
            checked={true}
            //   onChange={(checked) => setShowHomePage(checked)}
          ></Switch>
          <span>Active</span>
        </div>
      </TopCard>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-4 pb-4">
        {/* Left Section */}
        <div className="lg:col-span-2 space-y-4">
          <Card>
            <div className="flex justify-between items-center">
              <div className="flex justify-start items-center">
                <h3 className="mr-3 text-[#2D3643] text-[22px] font-bold">
                  Package #1
                </h3>
                <Button
                  className="!border-[#4A72FF] !text-[#4A72FF]"
                  icon={<EditIcon />}
                  // onClick={() => handleOpen({ type: "UPDATE" })}
                >
                  Change Package
                </Button>
              </div>

              <div>
                <h3 className="text-[#2D3643] font-semibold text-[18px]">
                  <span className="text-[32px] font-bold">৳ 7999</span>/ Yearly
                </h3>
              </div>
            </div>

            <div className="mt-4 mb-4 text-sm font-medium">
              <span className="text-[#2D3643] mr-3">For 15 Employees</span>{" "}
              <Switch checked={false} />{" "}
              <span className="text-[#8897AE] ml-1">Custom</span>
            </div>

            <div className="border-b border-[#AFBACA] pb-2">
              <h3 className="text-[#2D3643] text-base font-medium">
                Features:
              </h3>

              <div className="grid grid-cols-3 gap-4 gap-y-0 mt-2">
                <Radio.Group
                  className="custom-radio w-full"
                  size="large"
                  // value={payScheduleData?.pay_day_type}
                  // onChange={(e) =>
                  //   handlePaySchedule("pay_day_type", e.target.value)
                  // }
                  defaultValue="last_working_day"
                >
                  <Radio
                    value="last_working_day"
                    className=" text-header text-sm font-normal mr-3.5 mb-4"
                  >
                    Features title will go here
                  </Radio>
                </Radio.Group>

                <Radio.Group
                  className="custom-radio w-full"
                  size="large"
                  // value={payScheduleData?.pay_day_type}
                  // onChange={(e) =>
                  //   handlePaySchedule("pay_day_type", e.target.value)
                  // }
                  defaultValue="last_working_day"
                >
                  <Radio
                    value="last_working_day"
                    className=" text-header text-sm font-normal mr-3.5 mb-4"
                  >
                    Features title will go here
                  </Radio>
                </Radio.Group>

                <Radio.Group
                  className="custom-radio w-full"
                  size="large"
                  // value={payScheduleData?.pay_day_type}
                  // onChange={(e) =>
                  //   handlePaySchedule("pay_day_type", e.target.value)
                  // }
                  defaultValue="last_working_day"
                >
                  <Radio
                    value="last_working_day"
                    className=" text-header text-sm font-normal mr-3.5 mb-4"
                  >
                    Features title will go here
                  </Radio>
                </Radio.Group>

                <Radio.Group
                  className="custom-radio w-full"
                  size="large"
                  // value={payScheduleData?.pay_day_type}
                  // onChange={(e) =>
                  //   handlePaySchedule("pay_day_type", e.target.value)
                  // }
                  defaultValue="last_working_day"
                >
                  <Radio
                    value="last_working_day"
                    className=" text-header text-sm font-normal mr-3.5 mb-4"
                  >
                    Features title will go here
                  </Radio>
                </Radio.Group>

                <Radio.Group
                  className="custom-radio w-full"
                  size="large"
                  // value={payScheduleData?.pay_day_type}
                  // onChange={(e) =>
                  //   handlePaySchedule("pay_day_type", e.target.value)
                  // }
                  defaultValue="last_working_day"
                >
                  <Radio
                    value="last_working_day"
                    className=" text-header text-sm font-normal mr-3.5 mb-4"
                  >
                    Features title will go here
                  </Radio>
                </Radio.Group>

                <Radio.Group
                  className="custom-radio w-full"
                  size="large"
                  // value={payScheduleData?.pay_day_type}
                  // onChange={(e) =>
                  //   handlePaySchedule("pay_day_type", e.target.value)
                  // }
                  defaultValue="last_working_day"
                >
                  <Radio
                    value="last_working_day"
                    className=" text-header text-sm font-normal mr-3.5 mb-4"
                  >
                    Features title will go here
                  </Radio>
                </Radio.Group>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 gap-y-0 mt-4">
              <div>
                <h4 className="text-sm text-[#8897AE] font-medium">
                  Package Expire
                </h4>
                <h3 className="text-base text-display-body font-medium">
                  20 Jan, 2026
                </h3>
              </div>

              <div>
                <h4 className="text-sm text-[#8897AE] font-medium">
                  Payment Method
                </h4>
                <h3 className="text-base text-display-body font-medium">
                  bKash
                </h3>
              </div>

              <div>
                <h4 className="text-sm text-[#8897AE] font-medium">
                  Package Purchased
                </h4>
                <h3 className="text-base text-display-body font-medium">
                  02 Aug, 2022
                </h3>
              </div>
            </div>
          </Card>

          <CustomTable
            loading={false}
            limit={limit}
            page={page}
            columns={columns}
            total={100}
            dataSource={addKeyInArray(data)}
            handleLimit={handleLimit}
            handlePagination={handlePagination}
            filterSection={
              <>
                <Select
                  // defaultValue="lucy"
                  style={{ width: 120 }}
                  allowClear
                  suffixIcon={<SelectDownIcon />}
                  options={[
                    { value: "Active", label: "Active" },
                    { value: "Inactive", label: "Inactive" },
                    { value: "Review", label: "Review" },
                    { value: "Trial", label: "Trial" },
                  ]}
                  placeholder="Status"
                />

                <Select
                  // defaultValue="lucy"
                  style={{ width: 120 }}
                  allowClear
                  suffixIcon={<SelectDownIcon />}
                  options={[
                    { value: "Yearly", label: "Yearly" },
                    { value: "Monthly", label: "Monthly" },
                    { value: "Weekly", label: "Weekly" },
                    { value: "Daily", label: "Daily" },
                  ]}
                  placeholder="Yearly"
                />
              </>
            }
          />
        </div>

        {/* Right Section */}
        <div className="space-y-4">
          <div
            className="flex justify-between items-center w-80 h-[42px] bg-[#F0F3F9] shadow-sm rounded-lg pl-6 pr-4"
            style={{ border: "1px solid #E9EFF6" }}
          >
            <h5 className="text-lg font-semibold flex-shrink-0">Logs</h5>
          </div>

          <Card className="w-80">
            <div className="mt-1 space-y-4">
              {logs.map((log, index) => (
                <div key={index} className="relative pl-6">
                  {/* Timeline Connector */}
                  {index !== logs.length - 1 && (
                    <div className="absolute left-2 top-5 w-0.5 h-full border-l-2 border-[#AFBACA] border-dashed"></div>
                  )}
                  {/* Timeline Indicator */}
                  <div
                    className={`absolute left-0 w-4 h-4 rounded-full ${
                      statusColors[log.status]
                    }`}
                  ></div>

                  {/* Log Content */}
                  <div className="text-[12px] ml-3">
                    <div className="font-semibold text-gray-600 text-[#C19C60]">
                      {log.time} - {log.date}
                    </div>
                    <p className="text-gray-700 text-display-body text-sm mb-1">
                      {log.message}
                    </p>
                    <div className="text-blue-500  flex items-center">
                      <div className="flex items-center gap-2">
                        <span className="text-[#FE7235] w-4 h-4 inline-flex items-center justify-center">
                          <UserIcon />
                        </span>
                        <span className="text-nowrap italic text-[#8897AE]">
                          {log.user} -{" "}
                        </span>
                      </div>
                      <span className="font-medium text-gray-600 ml-1 text-nowrap italic text-[#8897AE]">
                        {log.role}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </SidebarLayout>
  );
}

interface LeaveDataType {
  key: string;
  accountNo: string;
  transactionsID: string;
  date: string;
  status: string;
  amount: number;
}

const data: LeaveDataType[] = [
  {
    key: "1",
    accountNo: "N/A",
    transactionsID: "XGTRE76CG000193",
    date: "12 Jan, 2024",
    status: "Active",
    amount: 7999,
  },
  {
    key: "2",
    accountNo: "1234XXXXXXXX123 Dhaka Banbk PLC",
    transactionsID: "XGTRE76CG000194",
    date: "12 Jan, 2024",
    status: "Review",
    amount: 7999,
  },
  {
    key: "3",
    accountNo: "1234XXXXXXXX123 Dhaka Banbk PLC",
    transactionsID: "XGTRE76CG000195",
    date: "12 Jan, 2024",
    status: "Trial Expired",
    amount: 7999,
  },

  {
    key: "4",
    accountNo: "1234XXXXXXXX123 Dhaka Banbk PLC",
    transactionsID: "XGTRE76CG000196",
    date: "12 Jan, 2024",
    status: "14 Days Trial",
    amount: 7999,
  },
];
